export default __webpack_public_path__ + "img/nophoto/nophoto.150x150.jpg";